import React from "react"
import { connect } from "react-redux"
import withQuery from "with-query"
import type {
  State,
  Report as ReportType,
  ReportApiResult
} from "../state_types"
import LoadablePage from "../components/LoadablePage"
import Theme from "../themes/Silver"
import Header from "../components/Header"
import LayoutWithHeader from "../components/LayoutWithHeader"
import SectionReport from "../components/reports/SectionReport"

type LoadableNewDemoPageProps = {
  loaded: boolean
  report: ReportType
  reportId: string
  subReportId: string
  reportUrl: string
  parentUrl: string
}

const SectionReportPage = ({
  loaded,
  report,
  reportId,
  subReportId,
  reportUrl,
  parentUrl
}: LoadableNewDemoPageProps) => (
  <Theme>
    <LayoutWithHeader
      header={
        <div>
          <Header />
        </div>
      }
    >
      <LoadablePage loaded={loaded}>
        {() =>
          React.createElement(SectionReport, {
            key: reportId,
            title: report.title,
            parentTitle: report.parentTitle,
            reportId,
            subReportId,
            reportData: report.reportData,
            filters: report.filters,
            reportUrl,
            returnTo: { to: parentUrl, name: `Report: ${report.parentTitle}` }
          })
        }
      </LoadablePage>
    </LayoutWithHeader>
  </Theme>
)

const mapStateToProps = (state: State) => {
  const report: ReportApiResult = state.report || {}
  const location = state.location || {}
  const query = location.query || {}

  return {
    loaded: !report.syncing,
    report: report.data,
    reportId: report.reportId,
    subReportId: report.subReportId,
    reportUrl: withQuery(location.pathname, location.search),
    parentUrl: withQuery(
      `/reports/${report.reportId}`,
      query && {
        framework: query.framework,
        organisation: query.organisation,
        group: query.group
      }
    )
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionReportPage)
